module.exports = __webpack_public_path__ + "media/images/529s/529s-logo-e355313eacbdc21ee1803b8e7c132a28.png";